<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <PageLoader v-if="loadingStatus === 'loading'" class="py-12" />
      <section class="recent-ancetry-wrapper" v-else-if="loadingStatus === 'loaded'">
        <div class="container">
          <div class="row">
            <MotherLineNavigation />
            <router-view />
          </div>
        </div>
      </section>
      <section class="recent-ancetry-wrapper" v-else-if="loadingStatus === 'failed'">
        <div class="container">
          <div class="row">
            <ParentalPageError type="mtdna" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script setup>
import Header from "@/components/header/Header.vue";
import MotherLineNavigation from "@/view/ancestry/motherline/MotherLineNavigation.vue";
import { useMotherlineStore } from "@/store/parentalStore";
import { useLoading } from "@/composables/useLoading";
import ParentalPageError from "@/view/ancestry/ParentalPageError.vue";
import { watch } from "vue";
import store from "@/store";

const motherlineStore = useMotherlineStore();
const { loadingStatus, finishLoading, failLoading } = useLoading();

watch(() => store.getters.profile,
  () => {
    motherlineStore
      .getResult()
      .then(() => {
        if (motherlineStore.result && Object.keys(motherlineStore.result).length === 0) {
          throw new Error("No result");
        }
      })
      .then(finishLoading)
      .catch(failLoading);
  }, { immediate: true });
</script>
